// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseNoteTemplate_container__1Y7O6","loading":"CaseNoteTemplate_loading__2kuIe"};